var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"slider",staticClass:"ctm-slider",style:({
    '--theme-color': ("var(--primary-" + _vm.theme + ")"),
    '--background-color': ("var(--primary-" + _vm.theme + "_10)")
  })},_vm._l((_vm.content),function(item){return _c('div',{key:(item.projectName || _vm.theme) + '_slider',staticClass:"ctm-slider__card"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.getProjectNameHTML(item.projectName) + item.projectText)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }